/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { SetAiCredentialMutationRequest, SetAiCredentialMutationResponse, SetAiCredentialPathParams, SetAiCredential400, SetAiCredential401, SetAiCredential403, SetAiCredential404, SetAiCredential409, SetAiCredential422, SetAiCredential500 } from "../../types/platformBillingController/SetAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getSetAiCredentialUrl(organizationId: SetAiCredentialPathParams["organizationId"]) {
  const res = { method: 'PUT', url: `/api/organizations/${organizationId}/platform-billing/credentials` as const }
  return res
}

/**
 * @summary Set (create or replace) a BYOK provider key
 * {@link /api/organizations/:organizationId/platform-billing/credentials}
 */
export async function setAiCredential(organizationId: SetAiCredentialPathParams["organizationId"], data: SetAiCredentialMutationRequest, config: Partial<RequestConfig<SetAiCredentialMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SetAiCredentialMutationResponse, ResponseErrorConfig<SetAiCredential400 | SetAiCredential401 | SetAiCredential403 | SetAiCredential404 | SetAiCredential409 | SetAiCredential422 | SetAiCredential500>, SetAiCredentialMutationRequest>({ method : "PUT", url : getSetAiCredentialUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}